import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { Permission } from 'app/models/permission';
import { PolicyRulesComponent } from './policy-rules/policy-rules.component';
import { PermissionService } from 'app/services/permission.service';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'ng-uikit-pro-standard';
import { Policy } from 'app/models/policy';
import { PolicyService } from 'app/services/policy.service';

@Component({
  selector: 'app-policies-permissions',
  templateUrl: './policies-permissions.component.html',
  styleUrls: ['./policies-permissions.component.scss']
})
export class PoliciesPermissionsComponent implements OnInit {

  @ViewChild(DatatableComponent, { static: true }) customRulesTable: DatatableComponent;
  @ViewChild('defaultPermissions', { static: true }) defaultPermissions: PolicyRulesComponent;

  tableLimitSelect: Array<any>;
  tableLoadingIndicator: boolean = false;
  selectedTableLimit: number = 5;

  externalTableLoadingIndicator: boolean = false;
  externalSelectedTableLimit: number = 5;

  customPolicies: Policy[] = [];
  externalPolicies: Policy[] = [];
  policyToDelete: Policy = null;
  
  isLoading: boolean = false;

  constructor(private ecoDocsTitleService: EcoDocsTitleService, private permissionService: PermissionService,
              private toastService: ToastService, private policyService: PolicyService) { }

  ngOnInit(): void {
    this.ecoDocsTitleService.setTitle('Policies and Permissions', false);
    this.tableLimitSelect = [5, 10, 20, 30, 50, 100];
    this.selectedTableLimit = 5;
    this.externalSelectedTableLimit = 5;

    this.isLoading = true;
    this.permissionService.getDefaultPermissions().pipe(finalize(() => { this.isLoading = false; })).subscribe(p => this.defaultPermissions.permissions = p, () => {
      this.toastService.error('Error getting default user policy!');
    });

    this.getAllPolicies();
    this.getAllExternalPolicies();
  }

  private getAllPolicies() {
    this.customPolicies = [];
    this.tableLoadingIndicator = true;
    this.policyService.getAll().pipe(finalize(() => { this.tableLoadingIndicator = false; })).subscribe(p => this.customPolicies = p, () => {
      this.toastService.error('Error getting custom policies!');
    });
  }

  private getAllExternalPolicies() {
    this.externalPolicies = [];
    this.externalTableLoadingIndicator = true;
    this.policyService.getAllExternal().pipe(finalize(() => { this.externalTableLoadingIndicator = false; })).subscribe(p => this.externalPolicies = p, () => {
      this.toastService.error('Error getting external access policies!');
    });
  }

  onSaveDefaultPermissions() : void {
    this.isLoading = true;
    this.permissionService.putDefaultPermissions(this.defaultPermissions.permissions).pipe(finalize(() => { this.isLoading = false; })).subscribe(null, () => {
      this.toastService.error('Error getting default user policy!');
    });
  }

  onDeleteCustomPolicy(id: number) {
    this.tableLoadingIndicator = true;
    this.policyService.deletePolicy(id).pipe(finalize(() => { this.tableLoadingIndicator = false; })).subscribe(() => {
      this.getAllPolicies();
      this.getAllExternalPolicies();
    }, () => {
      this.toastService.error('Error deleting policy!');
    });
  }

  getPermissionCategory(permission: Permission) : string {
    let result = "Miscellaneous";

    if (permission.name.startsWith('super.admin.users'))
      result = "Users";
    else if (permission.name.startsWith('super.admin.teams'))
      result = "Teams";
    else if (permission.name.startsWith('super.admin.contacts'))
      result = "Contacts";
    else if (permission.name.startsWith('super.admin.storage'))
      result = "External Storage";
    else if (permission.name.startsWith('super.admin.files'))
      result = "Global Files";
    else if (permission.name.startsWith('super.admin.forms'))
      result = "Forms";
    else if (permission.name.startsWith('super.admin.workflows'))
      result = "Workflows";
    else if (permission.name.startsWith('super.admin.dashboards'))
      result = "Quick Dashboards";
    else if (permission.name.startsWith('super.admin.reports'))
      result = "Reports";
    else if (permission.name.startsWith('super.admin.assign'))
      result = "Admin";
    else if (permission.name.startsWith('super.admin.data'))
      result = "Data";

    return result;
  }
}
